import { Box } from '@material-ui/core'
import { useState } from 'react'

import { HandlerOf } from '../../helpers/typeHelper'
import { ApiVersion } from '../../models'
import { NoteRecordType } from '../../models/note'
import { primaryBlack } from '../../theme/colors'
import { Grid } from '../Base/Base'
import { FlexBox } from '../Base/FlexBox'
import { Button } from '../Button/Button'
import { Text } from '../Text/Text'
import { NoteComposer } from './NoteComposer'
import { NotesTagsFilter } from './NotesTagsFilter'

interface NotesListProps {
  recordId: string
  recordType: NoteRecordType
  recordName?: string
  isTimeline?: boolean
  handleAddNote: (value: string, tags?: string[]) => Promise<void>
  showOnlyActivity: boolean
  setShowOnlyActivity: HandlerOf<boolean>
  filterTags: string[] | null
  setFilterTags: HandlerOf<string[] | null>
  apiVersion?: ApiVersion
  renderHeaderButton?: () => React.ReactNode
  isStatic?: boolean
}

export function NotesListHeader({
  recordId,
  recordType,
  recordName,
  isTimeline,
  handleAddNote,
  showOnlyActivity,
  setShowOnlyActivity,
  filterTags,
  setFilterTags,
  apiVersion,
  renderHeaderButton,
  isStatic,
}: NotesListProps) {
  const [isOpenComposer, setIsOpenComposer] = useState(false)

  function toggleOpenComposer() {
    setIsOpenComposer(!isOpenComposer)
  }

  async function onAddNote(text: string, tags?: string[]) {
    await handleAddNote(text, tags)
    setIsOpenComposer(false)
  }

  return (
    <div>
      <Grid columns="1fr auto" alignItems="center" styles="min-height: 40px;" gap="8px">
        <Text variant={isStatic ? 'header4' : 'header2'} fontColor={primaryBlack}>
          <FlexBox alignItems="center" gap="10px">
            Notes
            {recordName && !isStatic ? ` for ${recordName} ` : ' '}
          </FlexBox>
        </Text>
        <FlexBox gap="10px">
          {renderHeaderButton?.()}
          {isOpenComposer ? null : (
            <Button variant="secondary" size="medium" onClick={toggleOpenComposer}>
              Add
            </Button>
          )}
        </FlexBox>
      </Grid>

      <Box mt={3} />

      {isOpenComposer ? (
        <>
          <Box mt={1} />
          <NoteComposer
            onMessage={onAddNote}
            onCancel={() => setIsOpenComposer(false)}
            recordId={recordId}
            recordType={recordType}
          />
        </>
      ) : (
        <NotesTagsFilter
          recordId={recordId}
          recordType={recordType}
          showOnlyActivity={showOnlyActivity}
          setShowOnlyActivity={setShowOnlyActivity}
          filterTags={filterTags}
          setFilterTags={setFilterTags}
          isTimeline={isTimeline}
          apiVersion={apiVersion}
        />
      )}
      <Box mt={3} />
    </div>
  )
}
